export function titleWorldsAnimation() {
    function startTypingAnimation(container) {
        const words = container.querySelectorAll("span");
        let wordIndex = 0;
        let charIndex = 0;
        let isDeleting = false;
        let isVisible = false;
        let animationFrame;
        let cursor = document.createElement("span");
        cursor.classList.add("cursor");
        container.appendChild(cursor);

        function typeEffect() {
            if (!isVisible) {
                animationFrame = requestAnimationFrame(typeEffect);
                return;
            }

            let currentWord = words[wordIndex];
            let fullText = currentWord.dataset.originalText || currentWord.textContent;
            let displayedText = fullText.slice(0, charIndex);
            let wordLength = fullText.length;

            if (!currentWord.dataset.originalText) {
                currentWord.dataset.originalText = fullText;
            }

            words.forEach(word => word.style.display = "none");
            currentWord.style.display = "inline-block";
            currentWord.textContent = displayedText;
            cursor.style.backgroundColor = currentWord.style.color;

            let maxCursorWidth = Math.min(22, wordLength * 4.5);
            let minCursorWidth = 0;
            let cursorWidth = isDeleting
                ? minCursorWidth
                : maxCursorWidth - (charIndex / wordLength) * (maxCursorWidth - minCursorWidth);

            cursor.style.width = `${cursorWidth}px`;

            let typingSpeed = 800 / wordLength;

            if (!isDeleting && charIndex < wordLength) {
                charIndex++;
                setTimeout(typeEffect, typingSpeed);
            } else if (!isDeleting && charIndex === wordLength) {
                setTimeout(() => {
                    isDeleting = true;
                    charIndex = 0;
                    typeEffect();
                }, 2000);
            } else {
                isDeleting = false;
                wordIndex = (wordIndex + 1) % words.length;
                setTimeout(typeEffect, 0);
            }
        }

        function checkVisibility() {
            let rect = container.getBoundingClientRect();
            let windowHeight = window.innerHeight || document.documentElement.clientHeight;
            let isFullyVisible = rect.top >= 0 && rect.bottom <= windowHeight;

            if (isFullyVisible && !isVisible) {
                isVisible = true;
                typeEffect();
            } else if (!isFullyVisible) {
                isVisible = false;
                cancelAnimationFrame(animationFrame);
            }
        }

        window.addEventListener("scroll", checkVisibility);
        window.addEventListener("resize", checkVisibility);
        checkVisibility();
    }

    document.querySelectorAll(".title-worlds-animation").forEach(startTypingAnimation);
}


// WEBPACK FOOTER //
// ./assets/js/modules/titleWorldsAnimation.js